// React components
import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";

// Country form components
import CountryTable from "../../../analytics/components/Tables/CountryTable";

// Contexts
import { useFormPrevProjContext } from "contexts/contextFormPrevProj";

// Data formatting functions
import {
  formatGroupedDataToChart,
  formatPrevProjDataToChart,
} from "../../data/formatting/dataToChart";
import { formatPrevProjDataToTable } from "../../data/formatting/dataToTable";

function MainContent(): JSX.Element {
  const { countryData, isLoading, isError, errorMessage, refetch } = useFormPrevProjContext();
  const { prevalenceData, deathData, incidenceData, prevProjData } = countryData || {};
  const cardStatus = { isLoading, isError, errorMessage, onRetry: refetch };

  return (
    <DashboardLayout hasSideform>
      <DashboardNavbar hasSideform />
      <MDBox py={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DefaultLineChart
              {...cardStatus}
              icon={{ component: "show_chart" }}
              title="Prevalence, incidence and deaths"
              description="(case numbers)"
              yAxis={{
                prev: "Prevalence",
                inc_death: "Incidence and Deaths",
              }}
              chart={formatGroupedDataToChart(
                {
                  0: prevalenceData?.prevCoreData?.["total"],
                  1: deathData?.deathsCoreData?.["total"],
                  2: incidenceData?.incCasesData?.["total"],
                },
                {
                  labels: ["Prevalence", "Deaths", "Incidence"],
                  yAxisID: ["prev", "inc_death", "inc_death"],
                }
              )}
              height={300}
            />
          </Grid>
          <Grid item xs={12}>
            <VerticalBarChart
              {...cardStatus}
              icon={{ component: "bar_chart" }}
              title="Increase in point prevalence over period"
              description="(numbers)"
              stacked
              xAxis="Period"
              chart={formatPrevProjDataToChart(prevProjData, {
                labels: ["INCIDENCE", "MORTALITY", "DEMOGRAPHY", "EPIDEMIOLOGICAL DISEQUILIBRIUM"],
              })}
              height={300}
              legendPosition="chartArea"
            />
          </Grid>
          <Grid item xs={12}>
            <CountryTable
              {...cardStatus}
              icon={{ component: "table" }}
              title="Increase in point prevalence over period"
              description={`(numbers and relative changes)`}
              rows={formatPrevProjDataToTable(prevProjData)}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MainContent;
